import * as React from 'react';

 const QualityAssurance =(props)=>{
  return(<>
    <svg className={props.className} id="qualityAssurance"  width="26" height="25" viewBox="0 0 26 25" fill="#333333" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10.2633" cy="3.8133" r="2.99512" stroke="#333" strokeWidth="1.63637"/>
    <path d="M13.75 8.18164H8.18121C4.98153 8.18164 2.25082 10.4949 1.7248 13.651L1.31756 16.0945C1.15133 17.0919 1.92049 17.9998 2.93167 17.9998H7.75001" stroke="#333" strokeWidth="1.63637" strokeLinecap="round"/>
    <path d="M25 17.25C25 20.9779 21.9779 24 18.25 24C14.5221 24 11.5 20.9779 11.5 17.25C11.5 13.5221 14.5221 10.5 18.25 10.5C19.4963 10.5 20.6638 10.8378 21.6658 11.4268" stroke="#333" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M16 17.1L18.1429 19.5L23.5 13.5" stroke="#333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
    </>)
}
export default QualityAssurance
